/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';
import { daysToMs } from '../../utils/functions';

function getData() {
  return new Promise((resolve) => {
    get('https://d3cnadreq5uu0n.cloudfront.net/lebanon-war-data.json').then(
      (e) => {
        // get('data/lebanon-war-data.json').then((e) => {
        const d = JSON.parse(e);
        console.log('fetched data', d);
        resolve(d);
      },
    );
  });
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

function getEventTypes(dataGeo) {
  const eventTypes = dataGeo.features.map((d) => d.properties?.sub_event_type);
  return [...new Set(eventTypes)].filter(Boolean);
}

function getTimeRange(dataGeo) {
  const days = dataGeo.features
    .map((d) => Number(d.properties?.daySinceOrign))
    .filter((d) => Number.isFinite(d));

  const minDay = Math.min(...days);
  const maxDay = Math.max(...days);

  console.log('time range in days since 2027-02-28:', minDay, maxDay);
  return [minDay, maxDay];
}

function getDefaultFilterRange(timeRange) {
  const [minDay, maxDay] = timeRange;
  if (!Number.isFinite(minDay) || !Number.isFinite(maxDay)) return [0, 0];
  return [Math.max(minDay, maxDay - 2), maxDay];
}

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    dataGeo: [],
    data: [],
    eventtypes: [],
    loading: false,
    value: 1,
    timeRange: [0, 0],
    filterRange: [0, 0],
    viewState: null,
    animationSpeed: 5,
    isLoading: false,
    isAnimating: false,
  },
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setValue: (state, action) => {
      state.value = action.payload;
    },
    setFilterRange: (state, action) => {
      state.filterRange = action.payload;
    },
    setViewState: (state, action) => {
      state.viewState = action.payload;
    },
    setAnimating: (state, action) => {
      state.isAnimating = action.payload;
    },
    toggleAnimating: (state) => {
      state.isAnimating = !state.isAnimating;
    },
    setAnimationSpeed: (state, action) => {
      state.animationSpeed = action.payload;
    },
    resetAnimation: (state) => {
      state.filterRange = getDefaultFilterRange(state.timeRange);
      state.isAnimating = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      const timeRange = getTimeRange(action.payload);

      state.dataGeo = action.payload;
      state.eventtypes = getEventTypes(action.payload);
      state.timeRange = timeRange;
      state.filterRange = getDefaultFilterRange(timeRange);

      state.data = action.payload.features
        .map((d) => {
          const lon = Number(d.geometry?.coordinates?.[0]);
          const lat = Number(d.geometry?.coordinates?.[1]);
          const day = Number(d.properties?.daySinceOrign);

          if (
            !Number.isFinite(lon) ||
            !Number.isFinite(lat) ||
            !Number.isFinite(day)
          ) {
            return null;
          }

          return {
            position: [lon, lat],
            day,
            timestampMs: daysToMs(day),
            actor: d.properties?.actor1 || '',
            source: d.properties?.source || '',
            notes: d.properties?.notes || '',
            country: d.properties?.country || '',
            location: d.properties?.location || '',
            eventType: d.properties?.event_type || '',
            subEventType: d.properties?.sub_event_type || '',
          };
        })
        .filter(Boolean);

      state.loading = false;
    });
  },
});

export default data;
